// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Photos__row":"so_a bhc_a bhc_r bhc_j","Photos__img":"so_b bhc_b"};